import PreviewFrame from '../PreviewFrame';
import SplashLoginCard from '../SplashLoginCard';

const LoginPreview = ({ devicePreview, editable, selectedLanguage, languageOptions, setLanguageOptions, login, onUpdateLoginBlock, imageInfo, onUpdateImageBlock }) => {
  const isMobile = devicePreview === 'mobile';

  return (
    <PreviewFrame
      devicePreview={devicePreview}
      languageOptions={languageOptions}
      setLanguageOptions={setLanguageOptions}
      selectedLanguage={selectedLanguage}
      editable={editable}
      imageInfo={imageInfo}
      onUpdateImageBlock={onUpdateImageBlock}
    >
      <SplashLoginCard
        isMobile={isMobile}
        imageInfo={imageInfo}
        login={login}
        editable={editable}
        onUpdateLoginBlock={onUpdateLoginBlock}
        onUpdateImageBlock={onUpdateImageBlock}
      />
    </PreviewFrame>
  );
};
export default LoginPreview;
